// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__MUvcY","link":"styles_link__AJzuu","secondaryLink":"styles_secondaryLink__S7HT2"};